import { render, staticRenderFns } from "./another-person-actions.vue?vue&type=template&id=0e24979c&scoped=true&lang=pug&"
import script from "./another-person-actions.vue?vue&type=script&lang=js&"
export * from "./another-person-actions.vue?vue&type=script&lang=js&"
import style0 from "./another-person-actions.vue?vue&type=style&index=0&id=0e24979c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e24979c",
  null
  
)

export default component.exports